angular.module('maxfonder')
    .controller('DiskConfirmationMaxfonderCtrl', function ($scope, $location, $filter, $state, DiskService) {

        var registration = DiskService.getSavedRegistration();
        var confirmation;
        if (registration) {
            confirmation = DiskService.createAndSaveConfirmation(registration);
            DiskService.deleteRegistration();
        } else {
            confirmation = DiskService.getSavedConfirmation();
        }

        // show error if no existing confirmation
        $scope.hasConfirmation = confirmation != null;
        $scope.pdfId = confirmation != null ? confirmation.pdfId : null;
});
